<script setup lang="ts">
/**
 * App header component.
 * Matches cylian.org header structure.
 *
 * @component AppHeader
 */

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useUiStore } from '@/stores'

const route = useRoute()
const ui = useUiStore()

const isHome = computed(() => route.name === 'home')
const pageTitle = computed(() => (route.meta.title as string) || 'Page')

/**
 * Show dev indicator in development or preview environment.
 * Detects: Vite DEV mode OR hostname contains 'devel'.
 */
const isDev = import.meta.env.DEV || window.location.hostname.includes('devel')
</script>

<template>
  <!-- Logo -->
  <router-link to="/" id="logo" class="item">
    <object class="icon" data="/_img/logo/logo.svg" type="image/svg+xml"></object>
  </router-link>

  <!-- Breadcrumb -->
  <router-link to="/" class="item link screen-is-m-or-more">
    <span>Granite</span>
  </router-link>
  <span v-if="!isHome" class="item current leaf">
    <span>{{ pageTitle }}</span>
  </span>

  <!-- Spacer -->
  <span class="spacer"></span>

  <!-- Dev indicator -->
  <span v-if="isDev" class="tag fill color-warning" title="Development mode">
    <svg class="icon" fill="currentColor" height="1em" viewBox="0 0 24 24"><path d="M20,19V7H4V19H20M20,3A2,2 0 0,1 22,5V19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19V5C2,3.89 2.9,3 4,3H20M13,17V15H18V17H13M9.58,13L5.57,9H8.4L11.7,12.3C12.09,12.69 12.09,13.33 11.7,13.72L8.42,17H5.59L9.58,13Z"/></svg>
    <span>DEV</span>
  </span>

  <!-- New project -->
  <router-link to="/projects/new" class="item button" aria-label="Nouveau projet">
    <object class="icon" data="/_img/icon/plus.svg" type="image/svg+xml"></object>
  </router-link>

  <!-- Theme toggle (3 positions: auto, light, dark) -->
  <a
    id="systray-theme-toggle"
    class="item"
    aria-label="Toggle theme"
    @click="ui.toggleTheme"
  >
    <object class="icon theme-is-auto" data="/_img/theme/mode-auto.svg" type="image/svg+xml"></object>
    <object class="icon theme-is-light theme-is-forced" data="/_img/theme/mode-light.svg" type="image/svg+xml"></object>
    <object class="icon theme-is-dark theme-is-forced" data="/_img/theme/mode-dark.svg" type="image/svg+xml"></object>
  </a>

</template>
